import { Box, Chip, Paper, Typography } from '@mui/material';
import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite';

interface ModuleProps {
    title: string,
    category: string,
    moduleKey: string,
}

export default function Module({ title, category, moduleKey }: ModuleProps) {
    const openModule = (module) => {
        const moduleMap = {
            'build': 'https://www.nessle.com/module/build-your-nessle-storefront-and-listing-page',
            'testimonials': 'https://www.nessle.com/module/showcase-testimonials-from-happy-clients',
            'share': 'https://www.nessle.com/module/kickstart-your-client-growth-by-telling-the-world-youre-on-nessle',
            'prepare': 'https://www.nessle.com/module/prepare-for-your-first-session-on-the-nessle-platform',
            'bank': 'https://www.nessle.com/module/upload-bank-information-when-youre-ready-to-accept-transactions',
            'ideas': 'https://www.nessle.com/module/get-ideas-about-how-to-maximize-your-use-of-the-nessle-platform',
        };  

        window.open(moduleMap[module], '_blank');
    };

    return (
        <Box borderRadius={4} sx={{ cursor: 'pointer' }} onClick={() => openModule(moduleKey)}>
            <Paper elevation={0}>
                <Box p={2} display="flex" height={200} flexDirection="column" justifyContent="space-between">
                    <Typography variant="h6">
                        {title}
                    </Typography>
                    <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
                        <Chip color="secondary" label={category} />
                        <PlayCircleFilledWhiteIcon fontSize="large" color="primary" />
                    </Box>
                </Box>
            </Paper>
        </Box>
    );
}
